(function () {
  function initAddedCartModal() {
  const root = document.querySelector('[data-feystar-added-cart]');
  if (window.FeystarAddedCartModal) return;
  if (!root) {
    window.setTimeout(initAddedCartModal, 150);
    return;
  }

  const dialog = root.querySelector('.feystar-added-cart__dialog');
  const image = root.querySelector('[data-feystar-added-cart-image]');
  const title = root.querySelector('[data-feystar-added-cart-title]');
  const options = root.querySelector('[data-feystar-added-cart-options]');
  const quantity = root.querySelector('[data-feystar-added-cart-quantity]');
  const price = root.querySelector('[data-feystar-added-cart-price]');
  const count = root.querySelector('[data-feystar-added-cart-count]');
  const nativeFetch = typeof window.fetch === 'function' ? window.fetch.bind(window) : null;
  let activeElement = null;
  let lastItemKey = '';
  let lastOpenedAt = 0;

  function requestCart() {
    if (nativeFetch) {
      return nativeFetch('/cart.js', { headers: { Accept: 'application/json' } }).then((response) => response.json());
    }
    return new Promise((resolve, reject) => {
      const request = new XMLHttpRequest();
      request.open('GET', '/cart.js', true);
      request.setRequestHeader('Accept', 'application/json');
      request.onload = () => {
        if (request.status < 200 || request.status >= 300) {
          reject(new Error(`Cart request failed: ${request.status}`));
          return;
        }
        try {
          resolve(JSON.parse(request.responseText));
        } catch (error) {
          reject(error);
        }
      };
      request.onerror = () => reject(new Error('Cart request failed'));
      request.send();
    });
  }

  function escapeSelector(value) {
    return window.CSS && CSS.escape ? CSS.escape(value) : String(value).replace(/[^a-zA-Z0-9_-]/g, '');
  }

  function formatMoney(cents, currency) {
    const amount = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currency || window.Shopify?.currency?.active || 'USD',
      }).format(amount);
    } catch (error) {
      return `${window.Shopify?.currency?.active || '$'}${amount.toFixed(2)}`;
    }
  }

  function isVisibleProperty(name, value) {
    const key = String(name || '').trim();
    const text = String(value || '').trim();
    if (!key || !text || key.charAt(0) === '_') return false;
    if (/^(title|print\s*option|same\s*design|epoxy\s*style|accessories\s*style|accessories\s*color)$/i.test(key)) return false;
    if (/design\s*(file|preview|url)|cutline\s*(preview|url)|technical/i.test(key)) return false;
    if (/^https?:\/\//i.test(text) || text.indexOf('/uploads/') !== -1) return false;
    return true;
  }

  function getPreview(item) {
    const properties = item.properties || {};
    const previewEntry = Object.entries(properties).find(([name, value]) =>
      /preview/i.test(name) && /^https?:\/\//i.test(String(value || ''))
    );
    return previewEntry?.[1] || item.featured_image?.url || item.image || '';
  }

  function renderOptions(item) {
    options.replaceChildren();
    const values = [];
    const valueOnlyLabel = /^(size|print\s*option|epoxy\s*style|accessories\s*style|accessories\s*color)$/i;
    const removedLabel = /^(title|same\s*design)$/i;
    const removedValue = /^(double\s*sided\s*same\s*design|u\s*style)$/i;
    const hiddenValues = new Set();
    if (Array.isArray(item.options_with_values)) {
      item.options_with_values.forEach((option) => {
        if (option?.name && removedLabel.test(String(option.name).trim())) {
          return;
        } else if (option?.name && option?.value && removedValue.test(String(option.value).trim())) {
          return;
        } else if (option?.name && option?.value && valueOnlyLabel.test(String(option.name).trim())) {
          values.push(String(option.value));
          hiddenValues.add(String(option.value));
        } else if (option?.name && option?.value && isVisibleProperty(option.name, option.value)) {
          values.push(`${option.name}: ${option.value}`);
        }
      });
    }
    Object.entries(item.properties || {}).forEach(([name, value]) => {
      if (removedLabel.test(String(name).trim())) {
        return;
      } else if (valueOnlyLabel.test(String(name).trim())) {
        if (value && !removedValue.test(String(value).trim()) && !hiddenValues.has(String(value))) values.push(String(value));
      } else if (isVisibleProperty(name, value)) values.push(`${name}: ${value}`);
    });
    values.slice(0, 5).forEach((value) => {
      const line = document.createElement('p');
      line.textContent = value;
      options.appendChild(line);
    });
  }

  function updateCartCount(itemCount) {
    if (count) count.textContent = String(itemCount || 0);
  }

  function restoreCustomizerButton() {
    document.querySelectorAll('#ymq-custom-form button[type="submit"], .ymq-customizer-box .custom-add-to-cart').forEach((button) => {
      button.disabled = false;
      button.removeAttribute('aria-disabled');
      button.classList.remove('loading');
      const label = button.querySelector('span');
      if (label) label.textContent = 'Add to cart';
    });
  }

  function close() {
    if (root.hidden) return;
    root.hidden = true;
    document.documentElement.classList.remove('feystar-added-cart-open');
    if (activeElement && typeof activeElement.focus === 'function') activeElement.focus();
  }

  async function showFromAdd(addResponse) {
    const addedItems = Array.isArray(addResponse?.items) ? addResponse.items : [addResponse];
    const addedItem = addedItems.find(Boolean) || {};
    const key = String(addedItem.key || addedItem.id || '');
    const now = Date.now();
    if (key && key === lastItemKey && now - lastOpenedAt < 1200) return;
    lastItemKey = key;
    lastOpenedAt = now;

    let cart;
    try {
      cart = await requestCart();
    } catch (error) {
      cart = { item_count: addedItem.quantity || 1, currency: window.Shopify?.currency?.active, items: addedItems };
    }

    const cartItem = cart.items?.find((item) => item.key === addedItem.key)
      || cart.items?.find((item) => String(item.variant_id) === String(addedItem.variant_id || addedItem.id))
      || addedItem;
    const preview = getPreview(cartItem);

    title.textContent = cartItem.product_title || cartItem.title || 'Product';
    renderOptions(cartItem);
    const itemQuantity = Number(cartItem.quantity || addedItem.quantity || 1);
    const lineTotal = cartItem.final_line_price ?? cartItem.line_price ?? (Number(cartItem.final_price || cartItem.price || 0) * itemQuantity);
    price.textContent = formatMoney(lineTotal,
      cart.currency
    );
    quantity.textContent = `${itemQuantity} pcs`;
    if (preview) {
      image.src = preview;
      image.alt = cartItem.product_title || cartItem.title || 'Added product';
    } else {
      image.removeAttribute('src');
      image.alt = '';
    }
    const uploadedCount = (cart.items || []).filter((item) => {
      const properties = item.properties || {};
      return Object.entries(properties).some(([name, value]) => /design\s*(file|preview)|cutline\s*preview/i.test(name) && String(value || '').trim());
    }).length;
    updateCartCount(uploadedCount);

    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.close === 'function') drawer.close();
    activeElement = document.activeElement;
    root.hidden = false;
    document.documentElement.classList.add('feystar-added-cart-open');
    window.requestAnimationFrame(() => dialog.focus());
  }

  root.querySelectorAll('[data-feystar-added-cart-close]').forEach((button) => button.addEventListener('click', close));
  document.addEventListener('keydown', (event) => {
    if (!root.hidden && event.key === 'Escape') close();
  });

  window.FeystarAddedCartModal = { close, showFromAdd };

  if (nativeFetch) {
    window.fetch = async function (...args) {
      const response = await nativeFetch(...args);
      const request = args[0];
      const url = typeof request === 'string' ? request : request?.url || '';
      const method = String(args[1]?.method || request?.method || 'GET').toUpperCase();
      const isCartAdd = method === 'POST' && /\/cart\/add(?:\.js)?(?:\?|$)/.test(url);
      const isCustomizerAdd = isCartAdd && Boolean(document.querySelector('.ymq-customizer-box'));
      if (isCartAdd && response.ok) {
        response.clone().json().then(showFromAdd).catch(() => {});
        if (isCustomizerAdd) {
          restoreCustomizerButton();
          return new Promise(() => {});
        }
      }
      return response;
    };
  }

  const NativeXHR = window.XMLHttpRequest;
  if (NativeXHR && NativeXHR.prototype) {
    const nativeOpen = NativeXHR.prototype.open;
    const nativeSend = NativeXHR.prototype.send;
    NativeXHR.prototype.open = function (method, url, ...rest) {
      this.__feystarCartAdd = String(method || '').toUpperCase() === 'POST'
        && /\/cart\/add(?:\.js)?(?:\?|$)/.test(String(url || ''));
      return nativeOpen.call(this, method, url, ...rest);
    };
    NativeXHR.prototype.send = function (...args) {
      if (this.__feystarCartAdd) {
        this.addEventListener('load', () => {
          if (this.status >= 200 && this.status < 300) {
            try { showFromAdd(JSON.parse(this.responseText)); } catch (error) { /* non-JSON response */ }
          }
        }, { once: true });
      }
      return nativeSend.apply(this, args);
    };
  }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAddedCartModal, { once: true });
  } else {
    initAddedCartModal();
  }
  const initRetry = window.setInterval(() => {
    if (window.FeystarAddedCartModal) {
      window.clearInterval(initRetry);
      return;
    }
    try { initAddedCartModal(); } catch (error) { /* retry on dynamic product layouts */ }
  }, 500);
})();
